<div [class]="formGroupClass">
    <label for="myFile" [ngClass]="['btn', 'btn-secondary', 'mr-2', chooseFileDisabled ? 'disabled' : '']">Choose File</label>
    <input (change)="onFileSelect($event)" #input
        type="file" id="myFile" name="filename" [accept]="accept" [disabled]="chooseFileDisabled">
    <span>{{fileName}}</span>
</div>
